import type { BucketInterval } from './bucket-label'

export function bucketEnd(date: string, interval: BucketInterval): string {
  const [year, month, day] = date.split('-').map(Number)
  const end =
    interval === 'daily'
      ? Date.UTC(year, month - 1, day)
      : interval === 'weekly'
        ? Date.UTC(year, month - 1, day + 6)
        : Date.UTC(year, month, 0)
  return new Date(end).toISOString().slice(0, 10)
}
